export enum FutureTimeSourcesEnum {
  SNOOZE_AGAIN = 'SNOOZE_AGAIN',
  PRESET = 'PRESET',
  CUSTOM = 'CUSTOM',
}

export interface OnFutureTimeValueSelectOptions {
  datetime: number;
  source: FutureTimeSourcesEnum;
}
